import { render } from "./Pix.vue?vue&type=template&id=b5e035c0"
import script from "./Pix.vue?vue&type=script&lang=js"
export * from "./Pix.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__